export interface AdminLogoutCallbacks {
  requestServerLogout: () => Promise<unknown>;
  clearLocalToken: () => void;
  redirectToLogin: () => void;
  notifyServerLogoutSuccess: () => void;
  notifyServerLogoutUnconfirmed: () => void;
}

export async function completeAdminLogout({
  requestServerLogout,
  clearLocalToken,
  redirectToLogin,
  notifyServerLogoutSuccess,
  notifyServerLogoutUnconfirmed,
}: AdminLogoutCallbacks): Promise<void> {
  try {
    await requestServerLogout();
    notifyServerLogoutSuccess();
  } catch {
    notifyServerLogoutUnconfirmed();
  } finally {
    clearLocalToken();
    redirectToLogin();
  }
}
